import { Link, useNavigate } from "react-router-dom";
import { GLOBAL_IMAGES } from "../../../assets/asset";

const Header = ({ heading, subheading, name, subject }) => {
  const navigate = useNavigate();
  
  const hasProps = heading || subheading || name || subject;
  
  const handleMyBookings = () => {
    navigate("/classBooking/myBookings");
  };

  return (
    <header className="w-full px-8 py-4 bg-transparent fixed top-0 left-0 z-50">
      <div className="w-full flex items-center justify-between">
        <img
          src={GLOBAL_IMAGES.LoginBackButton}
          className="w-14 h-14 cursor-pointer"
          alt="back"
          onClick={() => navigate(-1)}
        />

        {hasProps && (
          <div className="text-center">
            <h1 className="text-3xl font-bold font-mali">{heading || "Welcome"}{name ? `, ${name}!` : "!"}</h1>
            <p className="text-lg -mt-1 font-mali">{subheading || "Let's help you excel"}{subject ? ` in ${subject}` : ""} today</p>
          </div>
        )}

        {hasProps && (
          <button onClick={handleMyBookings} className="px-6 py-3 rounded-full shadow-md font-semibold bg-white">
            My Bookings
          </button>
        )}
      </div>
    </header>
  );
};

export default Header;